import React from "react";
import { Button } from ".";

const RetreatCard = ({ image, date, place, price, link }) => {
  // Consider the retreat disabled if date or place is missing or placeholder
  const isDisabled =
    !date ||
    date === "To be announced soon" ||
    !place ||
    place === "To be announced soon";

  return (
    <div className="w-full max-w-2xl mx-auto flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden my-5 border border-gray-200">
      {/* Left Side - Image */}
      {image ? (
        <div className="w-full md:w-2/3 p-4 flex justify-center items-center">
          <img
            src={image}
            alt="Retreat"
            className="w-full h-auto object-cover rounded-lg"
          />
        </div>
      ) : (
        <div className="w-full md:w-2/3 p-6 flex justify-center items-center bg-gray-100">
          <p className="text-gray-600 italic">Image not available</p>
        </div>
      )}

      {/* Right Side - Content */}
      <div className="w-full md:w-2/3 p-6 flex flex-col justify-center">
        <p className="text-lg font-semibold text-primary">
          Date:{" "}
          <span className="text-[#578d48] font-bold">{date || "To be announced soon"}</span>
        </p>
        <p className="text-primary font-semibold mt-2">
          Place:{" "}
          <span className="text-gray-700 font-normal">{place || "To be announced soon"}</span>
        </p>
        <p className="text-primary font-semibold mt-1">
          Price:{" "}
          <span className="text-gray-700 font-normal">{price || "TBD"}</span>
        </p>
        <div className="mt-4">
          <Button
            variant="primary"
            size="sm"
            text="Book now"
            link={link}
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default RetreatCard;
